'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _providerEvents = require('wix-art-store-3rd-party/dist/src/sdk/providerEvents');

var _providerEvents2 = _interopRequireDefault(_providerEvents);

var _arrow = require('./arrow');

var _arrow2 = _interopRequireDefault(_arrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductsList = function ProductsList(props) {
  var data = props.data,
      onProviderAction = props.onProviderAction;

  return _react2.default.createElement(
    'div',
    {
      onClick: function onClick(e) {
        var node = e.target;
        var attr = null;
        var i = 5;
        do {
          if (node && node.getAttribute) {
            attr = node.getAttribute('data-index');
          }
          i--; // Prevent infinit loop
          node = node.parentNode;
        } while (node && !attr && i !== 0);
        var index = parseInt(attr);
        var item = data[index];
        onProviderAction(_providerEvents2.default.mobileItemClicked, item.dataKey);
      },
      className: 'artstore-products-list-container'
    },
    _react2.default.createElement(
      'div',
      { className: 'artstore-table-column artstore-image-column' },
      data.map(function (item, index) {
        return _react2.default.createElement(
          'div',
          {
            'data-index': index,
            className: 'artstore-table-cell artstore-table-image-container'
          },
          _react2.default.createElement('img', { className: 'artstore-table-image', src: item.imageSrc })
        );
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'artstore-table-column artstore-devider-column' },
      data.map(function (item, index) {
        return _react2.default.createElement('div', { 'data-index': index, className: 'artstore-table-cell' });
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'artstore-table-column artstore-title-column' },
      data.map(function (item, index) {
        return _react2.default.createElement(
          'div',
          { 'data-index': index, className: 'artstore-table-cell' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              { className: 'artstore-title' },
              item.title
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'span',
              { className: 'artstore-description' },
              item.subTitle
            )
          )
        );
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'artstore-table-column artstore-arrow-column' },
      data.map(function (item, index) {
        return _react2.default.createElement(
          'div',
          { 'data-index': index, className: 'artstore-table-cell' },
          _react2.default.createElement(
            'div',
            { className: 'artstore-arrow-container' },
            (0, _arrow2.default)()
          )
        );
      })
    )
  );
};

exports.default = ProductsList;